export const useAddUTMToAppState = () => {
  const addUTMToAppState = (appState: Record<string, unknown> = {}) => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmSourceStr = searchParams.get('utm_source');
    const utmCampaignStr = searchParams.get('utm_campaign');

    return {
      ...appState,
      utm: JSON.stringify({
        ...(utmSourceStr && { utm_source: utmSourceStr }),
        ...(utmCampaignStr && { utm_campaign: utmCampaignStr }),
      }),
    };
  };

  return { addUTMToAppState };
};
